/* eslint-disable max-lines */
import React, { ReactNode } from 'react';
import { PORTAL_HOME_TITLE } from 'common-package';
import { Helmet } from 'react-helmet';
import { RouterConfigEnum } from '../../constants';

export type MetaOptions = {
  title?: string;
  description?: string;
  keywords?: string;
};

const OG_IMG_URL = 'https://static.fuxi.netease.com/yaotai/portal/index/lcrnl2ro_035331.png';

const MetaConfigMap: Record<string, ({ title, description, keywords }: MetaOptions) => ReactNode> = {
  [RouterConfigEnum.Home]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>{PORTAL_HOME_TITLE}</title>
      <meta
        name="description"
        content="网易瑶台是网易伏羲研发的元宇宙展会活动共建平台，通过元宇宙生态、人工智能技术举办线上展会、活动，为主办方节省成本，促进数字活动传播，提高品牌营销价值。"
      />
      <meta name="keywords" content="网易瑶台,瑶台,元宇宙,网易元宇宙,元宇宙会议,元宇宙展会,元宇宙展会" />
      <meta property="og:title" content={PORTAL_HOME_TITLE} />
      <meta
        property="og:description"
        content="网易瑶台是网易伏羲研发的元宇宙展会活动共建平台，通过元宇宙生态、人工智能技术举办线上展会、活动，为主办方节省成本，促进数字活动传播，提高品牌营销价值。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.ProductFeature]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>数字化活动平台_元宇宙活动场景应用-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台数字化活动平台为全球客户输出元宇宙活动全流程解决方案，已完成上百场元宇宙活动经验总结积累，成功助力营销结果指数增长。"
      />
      <meta name="keywords" content="数字化活动平台,元宇宙场景应用,元宇宙活动,网易瑶台" />
      <meta property="og:title" content="数字化活动平台_元宇宙活动场景应用-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台数字化活动平台为全球客户输出元宇宙活动全流程解决方案，已完成上百场元宇宙活动经验总结积累，成功助力营销结果指数增长。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.Scene]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>线上场景解决方案_元宇宙应用场景解决方案-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台为在线会议、虚拟展会等元宇宙应用场景定制一站式解决方案，帮助主办方节省营销成本，助推品牌活动传播，提高品牌营销价值。"
      />
      <meta name="keywords" content="线上场景解决方案,元宇宙应用场景解决方案,在线会议,虚拟展会,网易瑶台" />
      <meta property="og:title" content="线上场景解决方案_元宇宙应用场景解决方案-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台为在线会议、虚拟展会等元宇宙应用场景定制一站式解决方案，帮助主办方节省营销成本，助推品牌活动传播，提高品牌营销价值。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [`${RouterConfigEnum.SceneCase}-learning`]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>学术会议解决方案_定制元宇宙线上学术会议-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台专为专家学者定制化打造元宇宙线上学术会议解决方案，融合视频研讨、线上社交、会议组织等多功能需求的沉浸式高品质学术会议。"
      />
      <meta
        name="keywords"
        content="学术会议解决方案,元宇宙线上学术会议,沉浸式线上学术会议,元宇宙会议,元宇宙解决方案,网易瑶台"
      />
      <meta property="og:title" content="学术会议解决方案_定制元宇宙线上学术会议-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台专为专家学者定制化打造元宇宙线上学术会议解决方案，融合视频研讨、线上社交、会议组织等多功能需求的沉浸式高品质学术会议。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [`${RouterConfigEnum.SceneCase}-industrySummit`]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>行业峰会解决方案_定制元宇宙线上行业峰会-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台专为主办方定制搭建元宇宙线上行业峰会，提高活动组织效率，通过音视频畅聊、场景定制、智能捏脸等AI技术给与参会者带来更加创新的沉浸式参会体验。"
      />
      <meta
        name="keywords"
        content="行业峰会解决方案,元宇宙线上行业峰会,沉浸式线上行业峰会,元宇宙会议,元宇宙解决方案,网易瑶台"
      />
      <meta property="og:title" content="行业峰会解决方案_定制元宇宙线上行业峰会-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台专为主办方定制搭建元宇宙线上行业峰会，提高活动组织效率，通过音视频畅聊、场景定制、智能捏脸等AI技术给与参会者带来更加创新的沉浸式参会体验。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [`${RouterConfigEnum.SceneCase}-carShow`]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>在线车展解决方案_定制元宇宙线上车展-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台在线车展解决方案将汽车一比一复刻进元宇宙，通过在线畅聊、在线询价、视频交流、名片交换、沉浸式洽谈等多元互动方式，给予参会者沉浸式车展体验，助力主办方构建专属元宇宙车展、提升数字化能力。"
      />
      <meta name="keywords" content="在线车展解决方案,元宇宙线上车展,沉浸式车展,元宇宙车展,元宇宙解决方案,网易瑶台" />
      <meta property="og:title" content="在线车展解决方案_定制元宇宙线上车展-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台在线车展解决方案将汽车一比一复刻进元宇宙，通过在线畅聊、在线询价、视频交流、名片交换、沉浸式洽谈等多元互动方式，给予参会者沉浸式车展体验，助力主办方构建专属元宇宙车展、提升数字化能力。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [`${RouterConfigEnum.SceneCase}-artShow`]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>在线艺术展解决方案_定制元宇宙艺术展-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台在线艺术展解决方案融合场景定制、创意策划、线上社交等多功能需求，支持参会者在元宇宙线上看展，节省展会成本，让艺术展传播更加高效。"
      />
      <meta name="keywords" content="在线艺术展解决方案,元宇宙艺术展,沉浸式艺术展,线上艺术展,元宇宙解决方案,网易瑶台" />
      <meta property="og:title" content="在线艺术展解决方案_定制元宇宙艺术展-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台在线艺术展解决方案融合场景定制、创意策划、线上社交等多功能需求，支持参会者在元宇宙线上看展，节省展会成本，让艺术展传播更加高效。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.AgentPage]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>瑶台授权代理商计划_共享元宇宙红利-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台招募代理商共享元宇宙红利，加入网易瑶台授权代理商，可享受网易瑶台产品的培训认证、销售咨询、技术对接和解决方案等服务。"
      />
      <meta name="keywords" content="瑶台代理商,网易代理商,元宇宙代理商" />
      <meta property="og:title" content="瑶台授权代理商计划_共享元宇宙红利-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台招募代理商共享元宇宙红利，加入网易瑶台授权代理商，可享受网易瑶台产品的培训认证、销售咨询、技术对接和解决方案等服务。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.AgentApply]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>瑶台授权代理商计划_共享元宇宙红利-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台招募代理商共享元宇宙红利，加入网易瑶台授权代理商，可享受网易瑶台产品的培训认证、销售咨询、技术对接和解决方案等服务。"
      />
      <meta name="keywords" content="瑶台代理商,网易代理商,元宇宙代理商" />
      <meta property="og:title" content="瑶台授权代理商计划_共享元宇宙红利-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台招募代理商共享元宇宙红利，加入网易瑶台授权代理商，可享受网易瑶台产品的培训认证、销售咨询、技术对接和解决方案等服务。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.KnowUs]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>网易瑶台是什么_了解网易瑶台</title>
      <meta name="description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta name="keywords" content="网易瑶台,网易瑶台联系方式,网易瑶台售前,网易瑶台售后" />
      <meta property="og:title" content="网易瑶台是什么_了解网易瑶台" />
      <meta property="og:description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  // [RouterConfigEnum.Posts]: () => (
  //   <Helmet>
  //     {/* autocorrect: false */}
  //     <title>新闻资讯-网易瑶台</title>
  //     <meta
  //       name="description"
  //       content="网易瑶台是网易伏羲旗下自主研发的在线虚拟活动平台，采用人工智能和科技创新，使活动突破时空限制并降低活动成本，打造线上活动新模式，开启元宇宙会议新体验。"
  //     />
  //     <meta name="keywords" content="网易瑶台,网易伏羲,虚拟活动平台,线上活动,元宇宙会议" />
  //     <meta property="og:title" content="新闻资讯-网易瑶台元宇宙" />
  //     <meta
  //       property="og:description"
  //       content="网易瑶台是网易伏羲旗下自主研发的在线虚拟活动平台，采用人工智能和科技创新，使活动突破时空限制并降低活动成本，打造线上活动新模式，开启元宇宙会议新体验。"
  //     />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  [RouterConfigEnum.ContactUs]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>联系我们-网易瑶台</title>
      <meta name="description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta name="keywords" content="网易瑶台,网易瑶台联系方式,网易瑶台售前,网易瑶台售后" />
      <meta property="og:title" content="联系我们-网易瑶台元宇宙" />
      <meta property="og:description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.Consult]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>联系我们-网易瑶台</title>
      <meta name="description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta name="keywords" content="网易瑶台,网易瑶台联系方式,网易瑶台售前,网易瑶台售后" />
      <meta property="og:title" content="联系我们-网易瑶台元宇宙" />
      <meta property="og:description" content="网易瑶台为您提供一站式的活动支持，和专业的售前售后服务" />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  // [RouterConfigEnum.Post]: ({ title, description }) => (
  //   <Helmet>
  //     <title>{title}</title>
  //     <meta name="description" content={description} />
  //     <meta
  //       name="keywords"
  //       content="网易瑶台，瑶台，沉浸式活动平台，metaverse，元宇宙，全真互联网，瑶台官网，网易元宇宙、元宇宙会议、元宇宙活动、元宇宙展会"
  //     />
  //     <meta property="og:title" content={title} />
  //     <meta property="og:description" content={description} />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  // [RouterConfigEnum.QuestionsList]: () => (
  //   <Helmet>
  //     {/* autocorrect: false */}
  //     <title>常见问题-网易瑶台</title>
  //     <meta property="og:title" content="常见问题-网易瑶台元宇宙" />
  //     <meta
  //       property="og:description"
  //       content="瑶台是网易伏羲研发的沉浸式活动平台，人工智能技术给您带来全新的体验，在精美的虚拟世界中，完成一次超凡的线上活动。"
  //     />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  // [RouterConfigEnum.Questions]: ({ title, description }) => (
  //   <Helmet>
  //     <title>{title}</title>
  //     <meta name="description" content={description} />
  //     <meta
  //       name="keywords"
  //       content="网易瑶台，瑶台，沉浸式活动平台，metaverse，元宇宙，全真互联网，瑶台官网，网易元宇宙、元宇宙会议、元宇宙活动、元宇宙展会"
  //     />
  //     <meta property="og:title" content={title} />
  //     <meta property="og:description" content={description} />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  [RouterConfigEnum.DownloadWay]: () => (
    <Helmet>
      <title>网易瑶台客户端_手机 APP 下载</title>
      <meta name="description" content="网易瑶台客户端、APP等多种活动参与方式，随心选择随时随地，一键参会。" />
      <meta name="keywords" content="网易瑶台客户端,网易瑶台APP,网易瑶台下载,网易瑶台APP下载" />
      <meta property="og:title" content="网易瑶台客户端_手机APP下载" />
      <meta property="og:description" content="网易瑶台客户端、APP等多种活动参与方式，随心选择随时随地，一键参会。" />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.ActivityCenter]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>活动广场-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台活动展示入口，线上数字会议、元宇宙会议一键报名，多种方式线上看展随心选择，精彩活动，尽在网易瑶台。"
      />
      <meta name="keywords" content="网易瑶台,线上数字会议,元宇宙会议,线上活动,报名线上看展" />
      <meta property="og:title" content="活动广场-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台活动展示入口，线上数字会议、元宇宙会议一键报名，多种方式线上看展随心选择，精彩活动，尽在网易瑶台。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.EventEntrance]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>活动广场-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台活动展示入口，线上数字会议、元宇宙会议一键报名，多种方式线上看展随心选择，精彩活动，尽在网易瑶台。"
      />
      <meta name="keywords" content="网易瑶台,线上数字会议,元宇宙会议,线上活动,报名线上看展" />
      <meta property="og:title" content="活动广场-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台活动展示入口，线上数字会议、元宇宙会议一键报名，多种方式线上看展随心选择，精彩活动，尽在网易瑶台。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  // [RouterConfigEnum.MaterialCenter]: () => (
  //   <Helmet>
  //     {/* autocorrect: false */}
  //     <title>资料库-网易瑶台</title>
  //     <meta
  //       name="description"
  //       content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
  //     />
  //     <meta name="keywords" content="网易瑶台,元宇宙会议,元宇宙行业报告,活动视频,会议案例" />
  //     <meta property="og:title" content="资料库-网易瑶台元宇宙" />
  //     <meta
  //       property="og:description"
  //       content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
  //     />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  // [RouterConfigEnum.MaterialDetail]: () => (
  //   <Helmet>
  //     {/* autocorrect: false */}
  //     <title>资料库-网易瑶台</title>
  //     <meta
  //       name="description"
  //       content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
  //     />
  //     <meta name="keywords" content="瑶台代理商,网易代理商,元宇宙代理商" />
  //     <meta property="og:title" content="资料库-网易瑶台元宇宙" />
  //     <meta
  //       property="og:description"
  //       content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
  //     />
  //     <meta property="og:type" content="article" />
  //     <meta property="og:image" content={OG_IMG_URL} />
  //     <meta property="og:image:url" content={OG_IMG_URL} />
  //   </Helmet>
  // ),
  [RouterConfigEnum.Additional]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>资料库-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
      />
      <meta name="keywords" content="网易瑶台,元宇宙会议,元宇宙行业报告,活动视频,会议案例" />
      <meta property="og:title" content="资料库-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台资料库展示上百场成功会议案例，还有精彩活动视频、元宇宙行业报告实时更新，帮助您了解网易瑶台。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
  [RouterConfigEnum.HelpCenter]: () => (
    <Helmet>
      {/* autocorrect: false */}
      <title>帮助中心-网易瑶台</title>
      <meta
        name="description"
        content="网易瑶台帮助中心集合瑶台使用手册、产品培训资料、视频教学和常见问题，让您快速上手网易瑶台。"
      />
      <meta name="keywords" content="网易瑶台,网易瑶台怎么玩,网易瑶台有哪些功能" />
      <meta property="og:title" content="帮助中心-网易瑶台元宇宙" />
      <meta
        property="og:description"
        content="网易瑶台帮助中心集合瑶台使用手册、产品培训资料、视频教学和常见问题，让您快速上手网易瑶台。"
      />
      <meta property="og:type" content="article" />
      <meta property="og:image" content={OG_IMG_URL} />
      <meta property="og:image:url" content={OG_IMG_URL} />
    </Helmet>
  ),
};

export const MetaConfig = (props: { routerPath: string } & MetaOptions) => {
  const { routerPath, ...metaOptions } = props;

  return <>{MetaConfigMap[routerPath]?.(metaOptions) || null}</>;
};
